import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';

export const SpinOptions = {
    suffix: i18n.t('厘米'),
    step: 0.1,
    allowDecimal: true,
    toFixed: 2,
    max: 50,
    min: 0,
};

export const DEFAULT_SCALE_STEP = 0.01; // 默认step

const SpinStyle = {
    fontSize: '12px',
};

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.SPIN,
        name: FormItemName.CELL_HEIGHT,
        label: FormItemLabelName.HEIGHT,
        options: SpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.CELL_WIDTH,
        label: FormItemLabelName.WIDTH,
        options: SpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
];
